import { motion } from "framer-motion";
import styled from "styled-components";
import theme from "../../../theme";

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  display: flex;
  align-items: left;
  gap: 4rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ContentSection = styled(motion.div)`
  flex: 1;
`;

const ProductLabel = styled.div`
  color: ${theme.colors.white};
  font-weight: 500;
  margin-bottom: 1rem;
  font-family: "Inter", sans-serif;
`;

const Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: ${theme.colors.white};
  font-family: "Inter", sans-serif;
`;

const Description = styled.p`
  color: ${theme.colors.white};
  margin-bottom: 2rem;
  font-size: 1.1rem;
  line-height: 1.8;
  font-family: "Inter", sans-serif;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.75rem;
  color: #1f2937;

  svg {
    color: ${theme.colors.tagborder};
    flex-shrink: 0;
  }

  span {
    font-weight: bold;
  }
`;

const GetStartedButton = styled.button`
  background-color: #ffffff;
  color: ${theme.colors.primary};
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${theme.colors.buttonhover};
    color: ${theme.colors.white};
  }
`;

const ImageContainer = styled(motion.div)`
  flex: 1;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 1rem;
`;

const TeamContianer = styled(motion.div)`
  padding: 4rem 2rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 4rem;
  }
  @media (max-width: 1024px) {
    gap: 4rem;
  }
`;

const TitleTeam = styled.h1`
  color: white;
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
`;

const HrTag = styled.hr`
  width: 60%;
  height: 2px;
  background: linear-gradient(
    to right,
    rgba(24, 83, 150, 0.8),
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0.6),
    rgba(24, 83, 150, 0.8)
  );
  border: none;
  border-radius: 2px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
`;

const SC = {
  Container,
  ContentSection,
  ProductLabel,
  Title,
  Description,
  FeatureList,
  FeatureItem,
  GetStartedButton,
  ImageContainer,
  Image,
  TeamContianer,
  Grid,
  TitleTeam,
  HrTag,
};

export default SC;
